<rt-dropdown [width]="DropdownWidth.Large" class="new-quick-evaluation">
  <div [formGroup]="quickEvaluationForm" (click)="$event.preventDefault()">
    <rt-dropdown-header [fullWidthTitle]="true" margin-bottom>
      {{ 'app.interview.is_candidate_good_fit' | translate }}
    </rt-dropdown-header>
    @if (offers && offers.length > 1) {
      <div class="offer-select" margin-lr margin-bottom>
        <ng-container *ngTemplateOutlet="offerSelect"></ng-container>
      </div>
    }

    <rt-interview-button-select
      [short]="true"
      [quickEvaluationStyle]="true"
      padding-lr
      formControlName="rating"
    >
    </rt-interview-button-select>
    <div class="advanced-button" padding-lr padding-tb-small>
      <rt-button (click)="handleClick(true)" variant="plain">
        {{ 'app.interview.advanced_options' | translate }}
      </rt-button>
    </div>
  </div>
</rt-dropdown>

<ng-template #offerSelect>
  <rt-offer-select
    [formControl]="$any(quickEvaluationForm.get('offerId'))"
    [offers]="offers"
    [hasSearch]="false"
    [hasInputTrigger]="true"
    [includeEmptyOption]="false"
  >
  </rt-offer-select
></ng-template>
